if(getShoptetDataLayer('customer').registered){

}
else{
    $('a[data-target="cart"]').remove();
    $('a[data-target="login"]').remove();
}